angular.module('unergie.main')
.controller('adminContentModalCtrl', ($scope, $uibModalInstance, NgTableParams, AdminContents, AlertManager, ErrorCatcher, contentId) => {
    $scope.contentId = contentId
    $scope.condDeployed = true

    const contentTemplate = {
        contentId,
        name: undefined,
        generalConditions: {},
        userConditions: {},
        priority: 100,
        content: '',
    }

    $scope.currentContent = undefined

    $scope.refresh = () => {
        $scope.fetchingContents = true
        return AdminContents.getContentForContentId({ contentId }).$promise.then((adminContents) => {
            $scope.adminContents = new NgTableParams({ sorting: { priority: 'desc' } }, { dataset: adminContents })
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingContents = false
        })
    }

    $scope.prettyPrint = function (elem, field) {
        try {
            elem[field] = JSON.parse(elem[field])
        } catch (error) {
            if (error.message.indexOf('at position ') > -1) {
                const start = Number(error.message.split('at position ')[1])
                const textarea = $(`#${field}`)
                if (textarea && textarea.length) {
                    textarea[0].focus()
                    textarea[0].selectionStart = start
                    textarea[0].selectionEnd = start + 1
                }
            }
            $scope[`${field}Ok`] = false
        }
        if (_.isObject(elem[field])) {
            elem[field] = JSON.stringify(elem[field], null, 4)
            $scope[`${field}Ok`] = true
        }
    }

    $scope.catchTab = function (id, event) {
        const keyCode = event.keyCode || event.which
        if (keyCode === 9) {
            const textarea = $(`#${id}`)
            event.preventDefault()
            const start = textarea[0].selectionStart
            const end = textarea[0].selectionEnd
            textarea.val(`${textarea.val().substring(0, start)}\t${textarea.val().substring(end)}`)
            textarea[0].selectionStart = start + 1
            textarea[0].selectionEnd = start + 1
        }
    }

    const selectContent = (content) => {
        $scope.currentContent = _.cloneDeep(content)
        $scope.currentContent.generalConditions = _.isString($scope.currentContent.generalConditions) ?
            $scope.currentContent.generalConditions :
            JSON.stringify($scope.currentContent.generalConditions || {})
        $scope.currentContent.userConditions = _.isString($scope.currentContent.userConditions) ?
            $scope.currentContent.userConditions :
            JSON.stringify($scope.currentContent.userConditions || {})
    }

    $scope.new = () => {
        selectContent(contentTemplate)
    }

    $scope.edit = (content) => {
        selectContent(content)
    }

    $scope.discard = () => {
        $scope.currentContent = undefined
    }

    $scope.delete = (content) => {
        content.deleting = true
        return AdminContents.deleteContent({ id: content._id }).$promise.then((adminContents) => {
            if ($scope.currentContent && $scope.currentContent._id === content._id) {
                $scope.discard()
            }
            $scope.refresh()
        }).catch(ErrorCatcher)
        .finally(() => {
            content.deleting = false
        })
    }

    $scope.canSave = () => {
        return $scope.currentContent.name && $scope.currentContent.content && $scope.currentContent.priority && $scope.currentContent.priority >= 0 && $scope.currentContent.priority <= 100
    }

    $scope.save = () => {
        $scope.savingContent = true
        const payload = _.omit($scope.currentContent, '_id')
        payload.userConditions = JSON.parse(payload.userConditions || '{}')
        // not using for now
        payload.generalConditions = {}
        return Promise.resolve().then(() => {
            if ($scope.currentContent._id) {
                return AdminContents.updateContent({ id: $scope.currentContent._id }, payload).$promise
            }
            return AdminContents.addContent(payload).$promise
        }).then((adminContents) => {
            AlertManager.success(`Contenu ${$scope.currentContent._id ? 'mis à jour' : 'ajouté'}`)
            $scope.discard()
            $scope.refresh()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.savingContent = false
        })
    }


    // RETURN OK
    $scope.close = () => $uibModalInstance.close()

    const activate = () => {
        $scope.refresh()
    }

    activate()
})
